import get from 'lodash/get'
import { isShelflifeBasedApp, isPsmBasedApp } from '../van-shared/utils/utils'
import { hasFeature } from '../van-shared/utils/features'
import { userIsAuthorised } from '../van-shared/utils/auth'

export const userHasIntercom = (config) => {
  return hasFeature(config.features, 'intercom') && process.env.NODE_ENV !== 'development'
}

export const addIntercom = (config) => {
  if (!userHasIntercom(config)) {
    return
  }

  const APP_ID = get(config.features.intercom, 'appId')

  const intercomScript = document.createElement('script')
  intercomScript.innerText = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==='function'){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + '${APP_ID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`
  document.head.appendChild(intercomScript)
}

export const bootIntercom = (config, user) => {
  if (!window.Intercom || !!window.intercomSettings) {
    return
  }

  const appId = get(config.features.intercom, 'appId')

  if (!appId) {
    return
  }

  let siteSource = ''
  const hasRole = (requiredRole) => {
    return Boolean(user && userIsAuthorised(user, requiredRole))
  }
  const isState = hasRole('feature:userRole:psm-state')
  const isLga = hasRole('feature:userRole:psm-lga')
  const isFacility = hasRole('feature:userRole:psm-facility')
  const isManager = hasRole('feature:userRole:psm-distribution-manager')
  const isDriver = hasRole('feature:userRole:psm-driver')
  const isWarehouse = hasRole('feature:userRole:psm-warehouse')
  const roleName = isLga ? 'lga' : isState ? 'state' : isDriver ? 'driver' : isFacility ? 'facility-manager' : isWarehouse ? 'warehouse-manager' : isManager ? 'distribution-manager' : 'user'

  if (isShelflifeBasedApp(config)) {
    siteSource = 'shelflife'
  }
  if (isPsmBasedApp(config)) {
    siteSource = 'fieldsupply'
  }

  window.intercomSettings = {
    app_id: appId,
    custom_launcher_selector: '.intercom-trigger',
    alignment: 'right',
    horizontal_padding: 20,
    vertical_padding: 20,
    hide_default_launcher: true,
    name: user ? user.name : '',
    'site_source': siteSource,
    'job_title': roleName
  }

  window.Intercom('boot')
}

export const bootIntercomBeforeLogin = async (config) => {
  if (!userHasIntercom(config)) {
    return
  }
  await addIntercom(config)
  await bootIntercom(config)
  window.Intercom('show')
}

export const bootIntercomAfterLogin = async (config, user) => {
  if (!userHasIntercom(config)) {
    return
  }
  await bootIntercom(config, user)
  window.Intercom('showNews')
}
